const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the likert scale component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('likertScale', [function () {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      value: '=',
      grade: '=',
      noEdit: '@'
    },
    template: require('../../../templates/directives/assessments/likert-scale.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      self.setChosen = function(num) {
        if ($scope.noEdit || !$scope.value) {
          return;
        }

        $scope.grade = (num / 5) * $scope.value;
        self.chosen = num;
      };

      if (!$scope.value) {
        return;
      }

      if ($scope.grade || $scope.grade === 0) {
        self.setChose(Math.round(($scope.grade / $scope.value) * 5));
      }
    }],
    controllerAs: 'likert'
  };
}]);